export const SET_SKU_LIST_COMMAND_CREATE_RESET = 'SET_SKU_LIST_COMMAND_CREATE_RESET'
export const SET_SKU_LIST_COMMAND_CREATE_SET_CREATED = 'SET_SKU_LIST_COMMAND_CREATE_SET_CREATED'
export const SET_SKU_LIST_COMMAND_CREATE_SET_ERROR = 'SET_SKU_LIST_COMMAND_CREATE_SET_ERROR'
export const SET_SKU_LIST_COMMAND_CREATE_SET_VIOLATIONS = 'SET_SKU_LIST_COMMAND_CREATE_SET_VIOLATIONS'
export const SET_SKU_LIST_COMMAND_CREATE_TOGGLE_LOADING = 'SET_SKU_LIST_COMMAND_CREATE_TOGGLE_LOADING'
